import { Component, Input } from '@angular/core';
import { DraggableDirective } from '@portal-shared/app/directives/draggable.directive';

@Component({
    selector: 'portal-draggable-card',
    template: `
    <div
      [portalDraggable]="payload"
      class="portal-box portal-box-border card-container"
      [class.error]="hasErrors">
      <ng-content select="[description]" />
      <ng-content select="[right]" />
    </div>
  `,
    styleUrls: ['./draggable-card.component.scss'],
    imports: [DraggableDirective]
})
export class DraggableCardComponent {
  @Input() public payload?: unknown;
  @Input() public hasErrors = false;
}
